import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { CustomJrpcErrResult } from "../jsonRpc/jRpcErrResponse";

export type ConfirmEmailOtpAuthRequest = {
    email: string,
    otp: string,
    locale: string
    current_entry_point: string
}

export type ConfirmEmailOtpAuthResponse = {
    tether: {
        suid: string;
        token: string;
    };
};

export function confirmEmailOtpAuth(
    data: ConfirmEmailOtpAuthRequest
): Promise<ConfirmEmailOtpAuthResponse | CustomJrpcErrResult> {
    return HubJsonRpcRequest.makeRequest<ConfirmEmailOtpAuthResponse, ConfirmEmailOtpAuthRequest>(
        HubApiMethods.CONFIRM_EMAIL_OTP_AUTH,
        data,
        window.app.deviceIdentifier
    );
}
